export const GLOBAL_PASS_THRESHOLD = 85;
